import { useEffect } from 'react';
import { useUserAgent } from '../../hooks/useUserAgent';
import { installLinksMap } from '../../components/InstallInstructionsModal';

type Props = {
  appName: string;
};

/**
 * MobileAppInstallPage — Redirects to the appropriate app store.
 *
 * On iOS redirects to Apple App Store, on Android to Google Play.
 * Renders nothing while redirecting.
 */
export default function MobileAppInstallPage({ appName }: Props) {
  const platform = useUserAgent();
  const links = installLinksMap[appName];

  useEffect(() => {
    if (!links) return;

    if (platform === 'android' && links.android) {
      window.location.href = links.android;
    } else if (platform === 'ios' && links.apple) {
      window.location.href = links.apple;
    }
  }, [platform, links]);

  return null;
}
